exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img[data-v-2e5a3f20]{height:40px;width:120px}a[data-v-2e5a3f20]{color:#a9a9a9;transition:.1s ease-in-out;margin:auto}a[data-v-2e5a3f20]:hover{text-decoration:none;transform:scale(1.05);color:#d3d3d3}.link_active[data-v-2e5a3f20]{color:#fff}.profile_pic[data-v-2e5a3f20]{height:30px;width:30px;border-radius:50%;margin-right:5px}@media screen and (max-width:992px){a[data-v-2e5a3f20]:hover{transform:none}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2e5a3f20","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Navbar.vue
// module id = 600
// module chunks = 0